import { TextInput as motiliUITextInput, TextInputProps } from '@motili/ui';
import styled, { css } from 'styled-components';

export interface StyledTextInputProps extends TextInputProps {
    marginTop?: '10px' | '20px' | 'none';
    withLabelSpacing?: boolean;
}

interface TransientProps {
    $marginTop?: '10px' | '20px' | 'none';
    $withLabelSpacing?: boolean;
}

const StyledTextInput = ({
    marginTop = 'none',
    withLabelSpacing = false,
    ...props
}: StyledTextInputProps) => {
    return (
        <TextInput
            $marginTop={marginTop}
            $withLabelSpacing={withLabelSpacing}
            {...props}
        />
    );
};

const TextInput = styled(motiliUITextInput)<TransientProps>`
    label {
        font-family: 'Nunito Sans', sans-serif;
        font-weight: 700;
        text-transform: uppercase;
    }
    ${props =>
        props.$marginTop &&
        props.$marginTop !== 'none' &&
        css`
            margin-top: ${props.$marginTop};
        `}

    ${props =>
        props.$withLabelSpacing &&
        css`
            div:first-child {
                margin-bottom: 10px;
            }
        `}
`;

export default StyledTextInput;
